<article>
  <header>
    <div class="flex-fill">
      <span id="order-title">{{ order.title }}</span>
      @if (order.onPremInstallation) {
        <div class="under-label">On Premises Installation</div>
      }
    </div>

    <div id="order-dates">
      <span>Start Date: {{ order.startDate | date: "yyyy-MM-dd" }}</span>
      <span>Due Date: {{ order.dueDate | date: "yyyy-MM-dd" }}</span>
    </div>
  </header>

  <section class="d-flex flex-wrap justify-content-around g-g">
    @if (order.orderType) {
      <div class="d-flex flex-column">
        <span class="pills-list-title">Status</span>
        <ul class="pills">
          <li class="pill">{{ ORDER_TYPE_CONFIG[order.orderType].label }}</li>
        </ul>
      </div>
    }

    @if (order.bom?.length) {
      <div class="d-flex flex-column">
        <span class="pills-list-title">Bill of Materials</span>
        <ul class="pills">
          <li class="pill">
            {{ order.bom! | billOfMaterialsProgress }} available
          </li>
        </ul>
      </div>
    }

    <div class="d-flex flex-column">
      <span class="pills-list-title">Assigned Tenants</span>
      <ul class="pills">
        <li class="pill">{{ order.tenantIds?.length ?? 0 }}</li>
      </ul>
    </div>
  </section>

  <div class="h-divider"></div>

  <section class="customer-info">
    <div class="d-flex flex-column">
      <span class="fw-bold">{{ order.customerName }}</span>
      <span>{{ order.customerEmailAddress }}</span>
      <div class="under-label">Customer</div>
    </div>

    @if (order.comments) {
      <em class="fw-bold">{{ order.comments }}</em>
    }
  </section>
</article>
